import React from 'react'
import "./Experience.css";
import {experience} from "../../../../Constants/Constants"

function Experience() {

    const exList = experience.map(ex => (<li>I work <strong>{ex.year}</strong> as a <strong>{ex.Position}</strong> in <strong>{ex.company}</strong> my jobs are as follows:- <br/><br/>{ex.jobs} </li>))
    return (
        <div className="experience">
        <div className="headingBackground" ><h2>My Experiences</h2></div>
        <div className="contentBackground">{exList}</div>
        </div>)
}
export default Experience
